/**
 * Compile time check of completeness of switch statements (exhaustiveness check)
 * Throws runtime error
 *
 * Read: https://basarat.gitbook.io/typescript/type-system/discriminated-unions#exhaustive-checks
 */
export function assertNever(_: never): never {
  throw new Error(`Non-exhaustive pattern matching. Received ${_}`);
}
